import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import * as numeral from 'numeral';
import { Cheque } from '../../../models/cheque';
import { Tarjeta } from '../../../models/tarjeta';

import { FormaPago } from '../../../models/forma-pago';
import { Validation } from '../../../config/validation';
import { CobroService } from '../../../services/cobro.service';
import { Cobro } from '../../../models/cobro';
import { CobroDetalle } from '../../../models/cobro_detalle';
import { SessionService } from '../../../services/session.service';
import { SweetMessage } from '../../../config/sweet-message';
import * as moment from 'moment';
import { DatosPagosComponent } from '../../../controls/datos-pago/datos-pago.component';
import { UtilsService } from '../../../services/utils.service';




import { VentaService } from '../../../services/venta.service';
import { Venta } from '../../../models/venta';
import { ClienteModalComponent } from '../../modals/cliente-modal/cliente-modal.component';

import { ClienteService } from '../../../services/cliente.service';
import { Cliente } from '../../../models/cliente';
import { Retencion } from '../../../models/retencion';
import { PlanAcumulativoService } from '../../../services/plan-acumulativo.service';
import { PlanAcumulativo } from '../../../models/plan-acumulativo';
import { ParametroService } from '../../../services/parametro.service';
import { FormaPagoService } from '../../../services/forma-pago.service';
import { ReporteModalComponent } from '../../modals/reporte-modal/reporte-modal.component';
import { Transferencia } from '../../../models/transferencia';
import { ParametroContabilidad } from '../../../models/parametro-contabilidad';
import { PeriodoContable } from '../../../models/periodo-contable';
import { PeriodoContableService } from '../../../services/periodo-contable.service';
import { ParametroContabilidadService } from '../../../services/parametro-contabilidad.service';
import { AsientoContable } from '../../../models/asiento-contable';
import { AsientoContableDetalle } from '../../../models/asiento-contable-detalle';
@Component({
  selector: 'app-cobro-grupo',
  templateUrl: './cobro-grupo.component.html',
  styleUrls: ['./cobro-grupo.component.css'],
 
  providers: [
    FormaPagoService,
    VentaService,
    ClienteService,
    PlanAcumulativoService,
    ParametroService,
    CobroService,
    ParametroContabilidadService,
    PeriodoContableService
  ]
})
export class CobroGrupoComponent implements OnInit {
    public ventas: Array<Venta>;
    public venta: Venta;
	public planes: Array<PlanAcumulativo>;
	public bsModalRef: BsModalRef;
	public cliente: Cliente;
	public loading = false;
	public numero_decimales: number;
    public format_decimal: String;


	public formasPago: Array<FormaPago>;
	public vl: Validation;
	public total_pago: number;
	public cambio: number;
	public cobro: Cobro;
	public msg: SweetMessage;
	public total_cobro: number;
	public cheques: Array<Cheque>;
    public tarjetas: Array<Tarjeta>;
    public transferencias: Array<Transferencia>;
	public valorefectivo: number;
	//public fecha_cobro;
	public total_facturas: any;
	public total:any;
	public total_retencion:any;
	public total_a_cobrar:any;
	public total_cobrado:any;
	public total_saldo:any;
	public fecha_cobro: any;
	public selectAll: boolean;
	public total_cheque: number = 0;
    public total_tarjeta: number = 0;
    public total_efectivo: number = 0;
    
    public plan:PlanAcumulativo;
    public cobros: Array<Cobro>;

    public tipo : String;
    public cobro_id: String;
    public guardado: boolean;
    public cliente_search:boolean;
    public cliente_id: String;
	public Mod_Cartera: string;
	public Mod_Contabilidad: string;
    public parametrosContabilidad: Array<ParametroContabilidad>;
    public periodoContable: PeriodoContable;
@ViewChild(DatosPagosComponent) datosPagos: DatosPagosComponent;
	constructor(
        public ventaService: VentaService,
		private NavRoute: Router,
		private modalService: BsModalService,
		public clienteService: ClienteService,
		public planAcumulativoService: PlanAcumulativoService,
		private parametroService: ParametroService,
        public utils: UtilsService,
        
        private activatedRoute: ActivatedRoute,
        public ss: SessionService,

        public formaPagoService: FormaPagoService,
        public cobroService: CobroService,
        private parametroContabilidadService: ParametroContabilidadService,
        private periodoContableService: PeriodoContableService,
	) {		
        this.ventas = [];
		this.planes = [];
		this.cliente = new Cliente();
		this.numero_decimales = 2;
        this.format_decimal = "0,0.00";
        this.cliente_id = "";

        
		
		this.total_facturas = 0;
		this.total =0;
		this.total_retencion = 0;
		this.total_a_cobrar = 0;
		this.total_cobrado = 0;
		this.total_pago = 0;
		this.total_saldo = 0;

		this.formasPago = [];
        this.vl = new Validation();
		this.cobro = new Cobro();
        this.msg = new SweetMessage();
        //this.total_cobro = 0;
        this.cheques = [];
        this.tarjetas = [];
        this.transferencias = [];
		this.valorefectivo = 0;
		let now = moment();
        this.fecha_cobro = moment(now.format(), moment.ISO_8601).format();
	//	this.fecha_pago = moment();
        this.selectAll = false;
        this.venta  = new Venta();
       // this.cambio = 0;
        this.msg = new SweetMessage();
        this.total_cobro = 0;
        this.plan = new PlanAcumulativo();
        this.cobros = [];
        this.cobro_id = "";
        this.guardado = false;
        this.cliente_search = false;
        this.Mod_Cartera = this.ss.getData("mod_cartera");
        this.Mod_Contabilidad = this.ss.getData("mod_contabilidad");
        this.parametrosContabilidad = [];
		this.periodoContable = new PeriodoContable();

	}

	ngOnInit() {
        this.loading = true;
		let p1 = this.getParamNumeroDecimales();
        
        let p2 = null;
		if( this.Mod_Cartera && this.Mod_Contabilidad ) {
			p2 = this.getParametroContabilidadCobros();
		}
       // let p3 = this.getListadoAbonos(); 
        Promise.all([p1,p2]).then(
            res => this.loading = false,
            err => this.loading = false
        );
    }


    getParametroContabilidadCobros(){
        return new Promise((resolve, reject) => {
			// let qs = "?in[id]=9,11,16,17,18,20,22&embed=cuentacontable";
			let qs = "?tipo=V&in[seccion]=IM,C&embed=cuentacontable";
			this.parametroContabilidadService.getAll(qs).subscribe(
				res => {
					let is_confirmedParametros = true;
					this.parametrosContabilidad.forEach(parametroContabilidad => {
						if( parametroContabilidad.cuenta_contable_id == null ){
							is_confirmedParametros = false;
							return false;
						}
					});
					if(!is_confirmedParametros){
						this.msg.showMessage('error-message', "Por favor, confirmar los parámetros de las cuentas contables.");
					}else{
						this.parametrosContabilidad = res.data;
					}
					resolve(true);
				},
				err => {
					reject(err);
				}
			);
            
        });
    }

    setValueAsientoContable(){
        
       
        let asientoContableCobros = new AsientoContable();
        asientoContableCobros.fecha_emision = this.cobro.fecha_cobro;
        asientoContableCobros.tipo_comprobante_id = null;
        asientoContableCobros.periodo_contable_id = this.periodoContable.id;
        asientoContableCobros.numero_documento = null;
        asientoContableCobros.descripcion = this.cliente.razon_social;
        asientoContableCobros.empresa_id = this.cobro.empresa_id;
        asientoContableCobros.usuario_id = this.cobro.usuario_id;
        asientoContableCobros.total = this.total_pago;
        asientoContableCobros.status = 'A';
		let valor_cheque= 0;
		let valor_tarjetas = 0;
		let valor_transferencias = 0;
		this.cheques.forEach(c=> {
			valor_cheque += Number(c.valor);
		});
		this.tarjetas.forEach(c=> {
			valor_tarjetas += Number(c.valor);
		});
		this.transferencias.forEach(c=> {
			valor_transferencias += Number(c.valor);
		});
        this.parametrosContabilidad.forEach(parametroContabilidad => {
            let asientoContableDetalle = new AsientoContableDetalle;
            asientoContableDetalle.empresa_id = asientoContableCobros.empresa_id;
			asientoContableDetalle.usuario_id = asientoContableCobros.usuario_id;
		
			if(parametroContabilidad.id == '14'){
                parametroContabilidad.tipo_saldo = "H";
                let total = Number(this.total_pago)*0.88;
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(total, this.numero_decimales):0;
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(total, this.numero_decimales):0;
				asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
				asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
            }
            
            if(parametroContabilidad.id == '6'){
                let total = Number(this.total_pago)*0.12;
                parametroContabilidad.tipo_saldo = "H";
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(total, this.numero_decimales):0;
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(total, this.numero_decimales):0;
				asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
				asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }   
			}
                asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
                asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
			if( parametroContabilidad.id == "10" && this.valorefectivo > valor_cheque && this.valorefectivo > valor_tarjetas && this.valorefectivo > valor_transferencias ) {
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
			}
			else if( parametroContabilidad.id == "11" && valor_cheque > this.valorefectivo && valor_cheque > valor_tarjetas && valor_cheque > valor_transferencias ) {
				
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
			}
			else if(  parametroContabilidad.id == "12" && valor_tarjetas > this.valorefectivo && valor_tarjetas > valor_cheque && valor_tarjetas > valor_transferencias ) {
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
			}
			else if( parametroContabilidad.id == "13"  && valor_transferencias > this.valorefectivo && valor_transferencias > valor_tarjetas && valor_transferencias > valor_cheque ) {
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
			}else if( parametroContabilidad.id == "10") {
                asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
			}
				
		});
        this.cobro.asientosContables.push(asientoContableCobros);
    }

    getPeriodoActual(){
        return new Promise((resolve, reject) => {
            let qs = "?periodo=" + moment().format('YYYY');
            this.periodoContableService.getPeriodoActual(qs).subscribe(
                res => {
                    this.periodoContable = res;
                    resolve(true);
                },
                err => {
                    reject(err);
                }
            );
        });
	}
    getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";

                    this.format_decimal = "0,0." + digitos
                    resolve();
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
    }

    get formatDecimal(){
        return this.format_decimal;
    }
    
    onSearchCliente(event) {
		if( event.keyCode === 13 ){
			if( this.cliente.dni.toString().trim().length == 0 ){
				this.cliente = new Cliente();
				this.ventas = [];
				return;
			}else{
				this.loading = true;
				this.clienteService.getByDni(this.cliente.dni).subscribe(
					res => {
						if (res.length > 0) {
							this.cliente = res[0];

							let p1 = this.getVentasCredito(this.cliente.id);
							let p2 = this.getPlanAcumulativo(this.cliente.id);

							Promise.all([p1,p2]).then(
								res => this.loading = false,
								err => this.loading = false,
							);
						}else{
							this.loading = false;
							this.cliente = new Cliente();
							this.ventas = [];
							this.openDialogCliente();
						}
					},
					err => {
						this.loading = false;
						this.ventas = [];
						this.openDialogCliente();
					}
				);
			}
		}
    }

    openDialogCliente() {
        this.cliente_search=false;
		const initialState = {cobros_pendientes: true};
		this.bsModalRef = this.modalService.show(ClienteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.sendCliente.take(1).subscribe(cliente => {
			this.cliente = cliente;

			this.loading = true;

			let p1 = this.getVentasCredito(this.cliente.id);
			let p2 = this.getPlanAcumulativo(this.cliente.id);

			Promise.all([p1,p2]).then(
				res => this.loading = false,
				err => this.loading = false,
			);
		});
    }
    
    getVentasCredito(cliente_id){
		return new Promise((resolve, reject) => {
			this.ventaService.getAll("?tipo=CR&embed=tipocomprobante,retencion&estado_pago=P&cliente_id="+cliente_id+"&sort=-fecha_emision,-secuencial&status=A").subscribe(
				res => {
					if( res.data.length ){
						this.ventas = res.data;
						this.ventas.forEach((venta: Venta) => {
							if( !venta.retencion ){
								venta.retencion = new Retencion();
							}
                        });
                        this.total_facturas = 0;
				
                        this.calcularTotalFacturas();
					}else{
						this.ventas = [];
					}
					resolve();
				},
				err => {
					this.ventas = [];
					reject(err);
				}
			);
		});
	}

	getPlanAcumulativo(cliente_id){
		return new Promise((resolve, reject) => {
			this.planAcumulativoService.getAll("?estado_pago=P&cliente_id=" + cliente_id + "&embed=tipocomprobante,cliente&sort=-secuencial").subscribe(
				res => {
					this.planes = res.data;
					resolve();
				},
				err => {
					this.planes = [];
					reject(err);
				}
			);
		});
	}

    numeroFactura(venta){
        return venta.serie + "-" + venta.punto_emision + "-" + venta.secuencial;
    }

    onSubmit(){
        this.msg.showMessage('delete-confirm-message', "¿Está seguro de confirmar el cobro?").then(
            res =>{
                this.setValueEntity();
                this.cliente_search=false;
                if( this.Mod_Cartera && this.Mod_Contabilidad ){

                    this.getPeriodoActual().then(
                        res => {
                            this.setValueAsientoContable();
                               this.saveCobro();   
                        }
                    );
                }else {
                   this.saveCobro();   
                }
            });
    }

    saveCobro(){
        this.loading = true;
               
        this.cobroService.saveGrupo(this.cobro).subscribe(
            res => {
                this.loading = false;
                this.msg.showMessage('success-message', res.message);
                //this.venta = new Venta();
                this.cliente_search=true;
                this.cobro = new Cobro();
                this.cambio = 0;
                this.total_pago = 0;
                this.cobro_id = JSON.parse(res.response._body).id;
                this.datosPagos.total_cheque = 0;
                this.datosPagos.total_tarjeta = 0;
                this.datosPagos.total_efectivo = 0;
                this.datosPagos.total_transferencia = 0;
                this.guardado =true;

                this.cheques = [];
                this.tarjetas = [];
                this.valorefectivo = 0;
                this.transferencias = [];
                this.cliente_id = this.cliente['id'];
                this.cliente = new Cliente();

                let now = moment();
                this.fecha_cobro = moment(now.format(), moment.ISO_8601).format();
                this.ventas = [];

                this.total_facturas = 0;
                this.total = 0;
                this.total_retencion = 0;
                this.total_a_cobrar = 0;
                this.total_cobrado = 0;
                this.total_saldo = 0;
            },
            err => {
                this.loading = false;
                this.msg.showMessage('error-message',err);
            }
        );
    }

    setValueEntity(){
        this.cobro.fecha_cobro = moment(this.fecha_cobro).format("YYYY-MM-DD");

        this.cobro.saldo = (this.tipo=="VE"?(this.venta.total - this.venta.abonado):(this.plan.total - this.plan.abonado));

        //this.cobro.saldo = this.venta.total - this.venta.abonado;
        this.cobro.recibido = this.total_pago;
        this.cobro.cambio = 0;
        this.cobro.tipo_doc = (this.tipo=="VE"?"FAC":"PACUM");
        this.cobro.tipo_documento_id = null;
      //  this.cobro.tipo_documento_id = (this.tipo=="VE"?this.venta.id:this.plan.id);
        //this.cobro.caja_id = this.ss.getData("caja_id");
        this.cobro.empresa_id = this.ss.getData("empresa_id");
        this.cobro.sucursal_id = this.ss.getData("sucursal_id");
        this.cobro.usuario_id = this.ss.getData("usuario_id");

        if( this.valorefectivo > 0 ){
            let cobro_detalle = new CobroDetalle();
            cobro_detalle.valor = this.valorefectivo;
            cobro_detalle.forma_pago_id = "1"; // EFECTIVO
            cobro_detalle.empresa_id = this.ss.getData("empresa_id");
            cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
            cobro_detalle.usuario_id = this.ss.getData("usuario_id");
            this.cobro.detalle.push(cobro_detalle);
        }

        this.cheques.forEach(ch => {
            let cobro_detalle = new CobroDetalle();

            cobro_detalle.fecha_cheque = ch.fecha;
            cobro_detalle.numero_cta = ch.cuenta;
            cobro_detalle.numero_cheque = ch.numero;
            cobro_detalle.banco_id = ch.banco_id;
            cobro_detalle.observacion = ch.observacion;
            cobro_detalle.valor = ch.valor;
            cobro_detalle.forma_pago_id = ch.forma_pago_id; // CHEQUE
            cobro_detalle.empresa_id = this.ss.getData("empresa_id");
            cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
            cobro_detalle.usuario_id = this.ss.getData("usuario_id");
            this.cobro.detalle.push(cobro_detalle);
        });

        this.tarjetas.forEach(tr => {
            let cobro_detalle = new CobroDetalle();

            cobro_detalle.debito_credito = tr.debito_credito;
            cobro_detalle.observacion = tr.observacion;
            cobro_detalle.tipo_tarjeta_id = tr.tipo_id;
            cobro_detalle.valor = tr.valor;
            cobro_detalle.plazo = tr.plazo;
            cobro_detalle.tiempo = tr.tiempo;
            cobro_detalle.forma_pago_id = tr.forma_pago_id; // TARJETA
            cobro_detalle.empresa_id = this.ss.getData("empresa_id");
            cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
            cobro_detalle.usuario_id = this.ss.getData("usuario_id");
            this.cobro.detalle.push(cobro_detalle);
        });

        this.transferencias.forEach(tr => {
			let cobro_detalle = new CobroDetalle();

			cobro_detalle.fecha_transferencia = tr.fecha;
			cobro_detalle.numero_cta = tr.cuenta;
			cobro_detalle.numero_comprobante = tr.numero;
			cobro_detalle.banco_id = tr.banco_id;
			cobro_detalle.observacion = tr.observacion;

			cobro_detalle.valor = tr.valor;
			cobro_detalle.forma_pago_id = tr.forma_pago_id; // TRANSFERENCIA
			cobro_detalle.empresa_id = this.ss.getData("empresa_id");
			cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
			cobro_detalle.usuario_id = this.ss.getData("usuario_id");
			this.cobro.detalle.push(cobro_detalle);
		});

        this.ventas.forEach((venta: any, index: number) => {
            if( venta.selected ){
    
                
                this.venta.usuario_id = this.ss.getData("usuario_id");
                this.venta.empresa_id = this.ss.getData("empresa_id");
    
                this.cobro.grupo.push(venta);
            }
    
            /*if( this.compra_selected == false){
                this.pago.grupo.splice(index, 1);
            }*/
        });
    }
    

	onChangeEfectivo(total){
		this.valorefectivo = total;
	}

	calcSaldo(venta){
        let saldo = venta.total - venta.abonado;

        if( venta.retencion ){
            saldo = saldo - venta.retencion.total;
        }
		//return saldo = Math.round(saldo * 100) / 100;
		return saldo = this.utils.redondear(saldo, this.numero_decimales);
    }

    calcularTotal(total){
        this.total_pago = total;
        this.total_pago = this.utils.redondear(this.total_pago,this.numero_decimales);
        let saldo = 0;

        if( this.tipo == "VE" ){
            //CALCULAR CAMBIO
            saldo = this.venta.total - this.venta.abonado;

            if( this.venta.retencion ){
                saldo = saldo - this.venta.retencion.total;
            }
        }else{
            saldo = this.plan.total - this.plan.abonado;
        }

       /* this.cambio = (this.total_pago > saldo?(this.total_pago - saldo):0);
        //this.cambio = Math.round( this.cambio * 100) / 100;
        this.cambio = this.utils.redondear(this.cambio, this.numero_decimales);*/
    }

    calcularTotalFacturas(){
		this.total_facturas = 0;
		this.total =0;
		this.total_retencion = 0;
		this.total_a_cobrar = 0;
		this.total_cobrado = 0;
		//this.total_pago = 0;
        this.total_saldo = 0;
        this.tipo = "VE";
		this.ventas.map(venta => {
			this.total += (parseFloat(venta.total.toString()));
			this.total = this.utils.redondear(this.total,this.numero_decimales);
			this.total_retencion += (parseFloat(venta.retencion.total.toString()));
			this.total = this.utils.redondear(this.total,this.numero_decimales);
			this.total_a_cobrar += (parseFloat(venta.total.toString()) - parseFloat(venta.retencion.total.toString()));
			this.total_a_cobrar = this.utils.redondear(this.total_a_cobrar,this.numero_decimales);
			this.total_cobrado += (parseFloat(venta.abonado.toString()));
			this.total_cobrado = this.utils.redondear(this.total_cobrado,this.numero_decimales);
			this.total_saldo += (this.calcSaldo(venta));
			this.total_saldo = this.utils.redondear(this.total_saldo,this.numero_decimales);
			if(venta.selected){
				this.total_facturas += (venta.total - venta.abonado - venta.retencion.total);
				this.total_facturas = this.utils.redondear(this.total_facturas,this.numero_decimales);
				
				//this.calcularCambio();
			}
			
		})
    }
    
    onSelectAll(){
		this.ventas.map(venta => venta.selected = this.selectAll);

		this.calcularTotalFacturas()
	}
	

    
  
    isFormValid(){
        if( this.fecha_cobro.toString().trim().length  === 0 ){
            return false;
        }
        if( this.total_pago <= 0 ){
            return false;
        }
        if( this.total_facturas == 0 ){
            return false;
        }
        if( this.total_pago != this.total_facturas ){
            return false;
        }
        return true;
    }

    imprimirComprobante(){
        let params = [];        
        params["empresa_id"] = this.ss.getData('empresa_id');
        params["usuario_id"] = this.ss.getData('usuario_id');

		
		if(this.tipo){
		
			params["tipo"] = this.tipo;
        }
		if(this.cliente_id){
		
			params["cliente_id"] = this.cliente_id;
		}
		if(this.cobro_id){
			params["cobro_id"] = this.cobro_id;
		}
	
		

        let qs = [];
        for(let key in params){
            let str = key + "=" + params[key];
            qs.push(str);
        }
		
		const initialState = { route: "cobro", qs: "?" + qs.join("&") + "&dbname=" + this.ss.getData('dbname') };
        this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));
    }

    getTotalSaldo(){
        let saldo = this.total_facturas - this.total_pago;
        return saldo = this.utils.redondear(saldo, this.numero_decimales); 
    }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/cobros/cobro-grupo/cobro-grupo.component.ts